<mat-toolbar class="app-header-toolbar" color="primary">
    <button
        type="button"
        class="logo-section"
        aria-label="Go to home"
        (click)="navigateToLanding()">
        <img class="unaavu-logo" src="assets/unaavu-logo.png" alt="" />
        <span class="unaavu-title">UNAAVU</span>
    </button>

    <div class="spacer"></div>

    <nav class="desktop-nav" role="navigation" aria-label="Main navigation">
      @if (!tableQrContext()) {
      <button matButton aria-label="Order for delivery" class="menu-btn" (click)="navigateToOrderForDelivery()">
          Order for Delivery
      </button>
      <button matButton aria-label="Order for takeaway" class="menu-btn" (click)="navigateToOrderForTakeaway()">
          Order Take Away
      </button>
      <button matButton aria-label="Book a table" class="menu-btn" (click)="navigateToBookATable()">
          Book a Table
      </button>
      <button matButton aria-label="Order at table" class="menu-btn" (click)="navigateToOrderFoodAtTable()">
          Order At Table
      </button>
      }
      @if (hasTrackingJwt()) {
      <button matButton aria-label="My orders" class="menu-btn" (click)="navigateToMyOrders()">
          My Orders
      </button>
      }
      <button matButton aria-label="About us" class="menu-btn" (click)="navigateToAboutUs()">
          About Us
      </button>
      <button matButton aria-label="Work with us" class="menu-btn" (click)="navigateToWorkWithUs()">
          Work with us
      </button>
    </nav>
    <div class="desktop-notif-actions">
    @if (orderTracking.liveSessionActive()) {
    <button
      mat-icon-button
      type="button"
      class="order-notif-btn"
      aria-label="Order and reservation status notifications"
      [matMenuTriggerFor]="orderNotifMenuDesktop"
      (click)="onOrderNotifClick()"
      title="Status updates">
      <mat-icon>notifications_active</mat-icon>
      @if (orderTracking.notificationUnread()) {
        <span class="order-notif-badge" aria-hidden="true"></span>
      }
    </button>
    <mat-menu #orderNotifMenuDesktop="matMenu" class="order-notif-menu-panel">
      <button mat-menu-item type="button" class="order-notif-plain" (click)="onOrderNotifMenuItemClick()">
        <span class="order-notif-menu-title">Status update</span>
        <span class="order-notif-menu-text">{{ orderNotifSummary() }}</span>
      </button>
    </mat-menu>
    }
    </div>

    <div class="mobile-nav-actions">
      @if (orderTracking.liveSessionActive()) {
      <button
        mat-icon-button
        type="button"
        class="order-notif-btn"
        aria-label="Order and reservation status notifications"
        [matMenuTriggerFor]="orderNotifMenuMobile"
        (click)="onOrderNotifClick()"
        title="Status updates">
        <mat-icon>notifications_active</mat-icon>
        @if (orderTracking.notificationUnread()) {
          <span class="order-notif-badge" aria-hidden="true"></span>
        }
      </button>
      <mat-menu #orderNotifMenuMobile="matMenu" class="order-notif-menu-panel">
        <button mat-menu-item type="button" class="order-notif-plain" (click)="onOrderNotifMenuItemClick()">
          <span class="order-notif-menu-title">Status update</span>
          <span class="order-notif-menu-text">{{ orderNotifSummary() }}</span>
        </button>
      </mat-menu>
      }
      <button
        mat-icon-button
        type="button"
        aria-label="Open navigation menu"
        class="menu-icon-btn"
        (click)="onToggleMobileMenu()">
        <mat-icon class="icon-large">{{ mobileMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
</mat-toolbar>

@if(mobileMenuOpen()){
<nav class="mobile-menu" role="navigation" aria-label="Mobile navigation">
    @if (!tableQrContext()) {
    <button matButton aria-label="Order for delivery" class="menu-btn" (click)="navigateToOrderForDelivery()">
        Order for Delivery
    </button>
    <button matButton aria-label="Order for takeaway" class="menu-btn" (click)="navigateToOrderForTakeaway()">
        Order Take Away
    </button>
    <button matButton aria-label="Book a table" class="menu-btn" (click)="navigateToBookATable()">
        Book a Table
    </button>
    <button matButton aria-label="Order at table" class="menu-btn" (click)="navigateToOrderFoodAtTable()">
        Order At Table
    </button>
    }
    @if (hasTrackingJwt()) {
    <button matButton aria-label="My orders" class="menu-btn" (click)="navigateToMyOrders()">
        My Orders
    </button>
    }
    <button matButton aria-label="About us" class="menu-btn" (click)="navigateToAboutUs()">
        About Us
    </button>
    <button matButton aria-label="Work with us" class="menu-btn" (click)="navigateToWorkWithUs()">
        Work with us
    </button>
</nav>
}
